import Vconsole from 'vconsole'
var vConsole = {}
if (process.env.NODE_ENV !== 'production') {
  vConsole = new Vconsole()
}

export default vConsole
